// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.area-executive-containers {
  overflow: hidden;
  height: 100vh;
}
.area-executive-containers .area-executive-main {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.area-executive-containers .area-executive {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.area-executive-containers .area-executive::-webkit-scrollbar {
  width: 0px;
}
.area-executive-containers .area-executive::-webkit-scrollbar-thumb {
  background: transparent;
}
.area-executive-containers .header-navigation {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
  width: 99.5%;
}
.area-executive-containers .area-executive-text {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  color: #2D2D2D;
  padding: 0.5rem;
}
.area-executive-containers .area-executive-heading {
  width: 97%;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.area-executive-containers .area-executive-profile {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  padding: 30px;
  border-radius: 8px;
  width: 98%;
  margin: auto;
  margin-bottom: 20px;
}
.area-executive-containers .area-executive-section .personal-info-label {
  border-bottom: 1px #10132E solid;
  overflow: visible;
  height: 5px;
  margin: 5px 0 10px 0;
  display: flex;
  align-items: center;
}
.area-executive-containers .area-executive-section .personal-info-label span {
  background-color: white;
  padding: 0 5px;
  font-weight: 600;
  font-size: 16px;
  width: 13%;
}
.area-executive-containers .area-executive-section .profile-info {
  display: flex;
  gap: 20px;
  padding: 40px 10px;
}
.area-executive-containers .area-executive-section .profile-info .img-container {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 10%;
  position: relative;
}
.area-executive-containers .area-executive-section .profile-info .img-container .user-profile {
  cursor: pointer;
  border: 2px solid #ccc;
  object-fit: cover;
  width: 120px;
}
.area-executive-containers .area-executive-section .profile-info .img-container .profile-plus-icons {
  margin-top: 10px;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  left: 42%;
}
.area-executive-containers .area-executive-section .profile-info .profile-input {
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
}
.area-executive-containers .area-executive-section .profile-info .profile-input p {
  white-space: nowrap;
  width: 30%;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .report-dropdown-select {
  outline: none;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields {
  display: flex;
  align-items: center;
  position: relative;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields label {
  position: absolute;
  top: -10px;
  left: 15px;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields input,
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  height: 50px;
  width: 80%;
  font-size: 16px;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .number_inp {
  height: 45px !important;
  font-size: 20px;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .react-tel-input {
  border-radius: 6px;
  position: relative;
  width: 70px;
  height: 3rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
  cursor: pointer;
  padding: 0px 5px;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .react-tel-input .form-control {
  border-radius: 6px;
  position: relative;
  width: 100%;
  height: 3rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 0.5rem;
  color: #10132e;
  cursor: pointer;
  border: none;
  background-color: white;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .react-tel-input .selected-flag {
  width: 17px !important;
  padding: 0 !important;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .react-tel-input .selected-flag .arrow {
  display: none;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .react-tel-input .flag-dropdown {
  background-color: white;
  border: none !important;
  height: 3rem;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .phone_input {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 50px;
  width: 80%;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .phone_input input {
  border: none;
  outline: none;
  padding: 5px;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .phone_input .phone_bar {
  margin: 0 3px;
  color: black;
  font-size: 23px;
  height: 2.5rem;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .multiselect_part {
  margin-left: 0px !important;
  height: 50px;
  width: 100% !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .multiselect_part fieldset {
  border: 1px solid #a3aec4;
  border-radius: 6px;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .multipleSelect_part {
  height: 50px;
  width: 80% !important;
}
.area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .multiselect_input {
  width: 100% !important;
  max-width: 200px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.area-executive-containers .area-executive-section .profile-info .profile-input:nth-child(2) {
  grid-column: span 2;
}
.area-executive-containers .cancel-submit-btn {
  display: flex;
  gap: 20px;
  margin-top: 50px;
}
.area-executive-containers .cancel-submit-btn .cancel-btn,
.area-executive-containers .cancel-submit-btn .submit-btn {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  width: 120px;
}
.area-executive-containers .cancel-submit-btn .cancel-btn {
  background-color: white;
  border: 1px solid #0C3688;
  color: #0C3688;
  cursor: pointer;
}
.area-executive-containers .cancel-submit-btn .submit-btn {
  background-color: #0C3688;
  color: white;
  cursor: pointer;
}
.area-executive-containers .cancel-submit-btn .submit-btn:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
  color: white;
}
.area-executive-containers .cancel-submit-btn .loader-btn {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 768px) {
  .area-executive-containers .area-executive-section .profile-info .profile-input {
    flex-grow: 1;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
  }
  .area-executive-containers .area-executive-profile {
    padding: 10px;
  }
  .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields input,
  .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields select {
    width: 70%;
  }
  .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .phone_input {
    width: 70%;
  }
  .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .multipleSelect_part {
    width: 100% !important;
  }
}
@media screen and (max-width: 480px) {
  .area-executive-containers .area-executive-section .profile-info .profile-input p {
    width: auto !important;
    position: absolute;
    z-index: 999;
    top: -9px;
    left: 12px;
    background: white;
    font-weight: 400 !important;
    font-size: 12px !important;
    padding: 2px;
  }
  .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields {
    position: relative;
  }
  .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields input, .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields select,
  .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .phone_input {
    width: 100%;
  }
  .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .multiselect_part {
    max-width: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/AddAreaExecutive/AddAreaExecutive.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAEI;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAUA,qBAAA;AATR;AACQ;EACE,UAAA;AACV;AAEQ;EACE,uBAAA;AAAV;AAMI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AAJR;AAOI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AALR;AAQI;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AANR;AASI;EACI,2CAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AAPR;AAWQ;EACI,gCAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AATZ;AAWY;EACI,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAThB;AAaQ;EACI,aAAA;EACA,SAAA;EACA,kBAAA;AAXZ;AAaY;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAXhB;AAagB;EACI,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AAXpB;AAcgB;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AAZpB;AAgBY;EACI,YAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAdhB;AAgBgB;EACI,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAdpB;AAiBgB;EACI,aAAA;AAfpB;AAkBgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAhBpB;AAkBoB;EACI,kBAAA;EACA,UAAA;EACA,UAAA;AAhBxB;AAmBoB;;EAEI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAjBxB;AAoBoB;EACI,uBAAA;EACA,eAAA;AAlBxB;AAqBoB;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnBxB;AAsBoB;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;AApBxB;AAuBoB;EACI,sBAAA;EACA,qBAAA;AArBxB;AAwBoB;EACI,aAAA;AAtBxB;AAyBoB;EACI,uBAAA;EACA,uBAAA;EACA,YAAA;AAvBxB;AA0BoB;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAxBxB;AA0BwB;EACI,YAAA;EACA,aAAA;EACA,YAAA;AAxB5B;AA2BwB;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAzB5B;AA6BoB;EACI,2BAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA3BxB;AA8BoB;EACI,yBAAA;EACA,kBAAA;AA5BxB;AA+BoB;EACI,YAAA;EACA,qBAAA;AA7BxB;AAgCoB;EACI,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9BxB;AAkCgB;EACI,mBAAA;AAhCpB;AAsCI;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AApCR;AAsCQ;;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AApCZ;AAuCQ;EACI,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AArCZ;AAwCQ;EACI,yBAAA;EACA,YAAA;EACA,eAAA;AAtCZ;AAyCQ;EACI,mEAAA;EACA,YAAA;AAvCZ;AA0CQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;AAxCZ;AA2CQ;EACI;IACI,uBAAA;EAzCd;EA4CU;IACI,yBAAA;EA1Cd;AACF;;AAgDA;EACI;IACI,YAAA;IACA,aAAA;IACA,qCAAA;IACA,SAAA;EA7CN;EAgDE;IACI,aAAA;EA9CN;EAiDE;;IAEI,UAAA;EA/CN;EAkDE;IACI,UAAA;EAhDN;EAmDE;IACI,sBAAA;EAjDN;AACF;AAoDA;EACI;IACI,sBAAA;IACA,kBAAA;IACA,YAAA;IACA,SAAA;IACA,UAAA;IACA,iBAAA;IACA,2BAAA;IACA,0BAAA;IACA,YAAA;EAlDN;EAqDE;IACI,kBAAA;EAnDN;EAsDE;;IAEI,WAAA;EApDN;EAuDE;IACI,0BAAA;EArDN;AACF","sourcesContent":[".area-executive-containers {\n    overflow: hidden;\n    height: 100vh;\n\n    .area-executive-main {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n    .area-executive {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: auto;\n        overflow-x: hidden;\n        height: calc(100vh - 66px);\n    \n        &::-webkit-scrollbar {\n          width: 0px;\n        }\n    \n        &::-webkit-scrollbar-thumb {\n          background: transparent;\n        }\n    \n        scrollbar-width: none;\n    }\n\n    .header-navigation {\n        background: #c0c8da;\n        height: 2.4rem;\n        border: 1px solid #c0c8da;\n        width: 99.5%;\n    }\n\n    .area-executive-text {\n        font-family: \"Nunito\";\n        font-size: 12px;\n        font-weight: 500;\n        color: #2D2D2D;\n        padding: 0.5rem;\n    }\n\n    .area-executive-heading {\n        width: 97%;\n        margin: auto;\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n\n    .area-executive-profile {\n        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n        padding: 30px;\n        border-radius: 8px;\n        width: 98%;\n        margin: auto;\n        margin-bottom: 20px;\n    }\n\n    .area-executive-section {\n        .personal-info-label {\n            border-bottom: 1px #10132E solid;\n            overflow: visible;\n            height: 5px;\n            margin: 5px 0 10px 0;\n            display: flex;\n            align-items: center;\n\n            span {\n                background-color: white;\n                padding: 0 5px;\n                font-weight: 600;\n                font-size: 16px;\n                width: 13%;\n            }\n        }\n\n        .profile-info {\n            display: flex;\n            gap: 20px;\n            padding: 40px 10px;\n\n            .img-container {\n                flex-shrink: 0;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                width: 10%;\n                position: relative;\n\n                .user-profile {\n                    cursor: pointer;\n                    border: 2px solid #ccc;\n                    object-fit: cover;\n                    width: 120px;\n                }\n\n                .profile-plus-icons {\n                    margin-top: 10px;\n                    cursor: pointer;\n                    position: absolute;\n                    bottom: 0;\n                    left: 42%;\n                }\n            }\n\n            .profile-input {\n                flex-grow: 1;\n                display: grid;\n                grid-template-columns: repeat(2, 1fr);\n                gap: 40px;\n\n                p {\n                    white-space: nowrap;\n                    width: 30%;\n                    font-weight: 600;\n                    margin-top: 0;\n                    margin-bottom: 0;\n                }\n\n                .report-dropdown-select {\n                    outline: none;\n                }\n\n                .input-fields {\n                    display: flex;\n                    align-items: center;\n                    position: relative;\n\n                    label{\n                        position: absolute;\n                        top: -10px;\n                        left: 15px;\n                    }\n\n                    input,\n                    select {\n                        padding: 10px;\n                        border: 1px solid #ccc;\n                        border-radius: 5px;\n                        font-size: 14px;\n                        height: 50px;\n                        width: 80%;\n                        font-size: 16px;\n                    }\n\n                    .number_inp {\n                        height: 45px !important;\n                        font-size: 20px;\n                    }\n\n                    .react-tel-input {\n                        border-radius: 6px;\n                        position: relative;\n                        width: 70px;\n                        height: 3rem;\n                        font-family: \"Nunito\";\n                        font-style: normal;\n                        font-weight: 600;\n                        font-size: 16px;\n                        color: #10132e;\n                        cursor: pointer;\n                        padding: 0px 5px;\n                    }\n\n                    .react-tel-input .form-control {\n                        border-radius: 6px;\n                        position: relative;\n                        width: 100%;\n                        height: 3rem;\n                        margin: 10px;\n                        font-family: \"Nunito\";\n                        font-style: normal;\n                        font-weight: 600;\n                        font-size: 16px;\n                        padding: 0rem 0.5rem;\n                        color: #10132e;\n                        cursor: pointer;\n                        border: none;\n                        background-color: white;\n                    }\n\n                    .react-tel-input .selected-flag {\n                        width: 17px !important;\n                        padding: 0 !important;\n                    }\n\n                    .react-tel-input .selected-flag .arrow {\n                        display: none;\n                    }\n\n                    .react-tel-input .flag-dropdown {\n                        background-color: white;\n                        border: none !important;\n                        height: 3rem;\n                    }\n\n                    .phone_input {\n                        display: flex;\n                        align-items: center;\n                        border: 1px solid #ccc;\n                        border-radius: 5px;\n                        height: 50px;\n                        width: 80%;\n\n                        input {\n                            border: none;\n                            outline: none;\n                            padding: 5px;\n                        }\n\n                        .phone_bar {\n                            margin: 0 3px;\n                            color: black;\n                            font-size: 23px;\n                            height: 2.5rem;\n                        }\n                    }\n\n                    .multiselect_part {\n                        margin-left: 0px !important;\n                        height: 50px;\n                        width: 100% !important;\n                        overflow: hidden;\n                        white-space: nowrap;\n                        text-overflow: ellipsis;\n                    }\n\n                    .multiselect_part fieldset {\n                        border: 1px solid #a3aec4;\n                        border-radius: 6px;\n                    }\n\n                    .multipleSelect_part {\n                        height: 50px;\n                        width: 80% !important;\n                    }\n\n                    .multiselect_input {\n                        width: 100% !important;\n                        max-width: 200px !important;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        white-space: nowrap;\n                    }\n                }\n\n                &:nth-child(2) {\n                    grid-column: span 2;\n                }\n            }\n        }\n    }\n\n    .cancel-submit-btn {\n        display: flex;\n        gap: 20px;\n        margin-top: 50px;\n\n        .cancel-btn,\n        .submit-btn {\n            padding: 10px 20px;\n            font-size: 14px;\n            font-weight: 600;\n            border-radius: 5px;\n            width: 120px;\n        }\n\n        .cancel-btn {\n            background-color: white;\n            border: 1px solid #0C3688;\n            color: #0C3688;\n            cursor: pointer;\n        }\n\n        .submit-btn {\n            background-color: #0C3688;\n            color: white;\n            cursor: pointer;\n        }\n\n        .submit-btn:disabled {\n            background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n            color: white;\n        }\n\n        .loader-btn {\n            border: 3px solid #f3f3f3;\n            border-top: 3px solid #3498db;\n            border-radius: 50%;\n            width: 18px;\n            height: 18px;\n            animation: spin 1s linear infinite;\n            display: inline-block;\n            vertical-align: middle;\n        }\n\n        @keyframes spin {\n            0% {\n                transform: rotate(0deg);\n            }\n\n            100% {\n                transform: rotate(360deg);\n            }\n        }\n\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .area-executive-containers .area-executive-section .profile-info .profile-input {\n        flex-grow: 1;\n        display: grid;\n        grid-template-columns: repeat(1, 1fr);\n        gap: 40px;\n    }\n\n    .area-executive-containers .area-executive-profile {\n        padding: 10px;\n    }\n\n    .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields input,\n    .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields select {\n        width: 70%;\n    }\n\n    .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .phone_input {\n        width: 70%;\n    }\n\n    .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .multipleSelect_part {\n        width: 100% !important;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .area-executive-containers .area-executive-section .profile-info .profile-input p {\n        width: auto !important;\n        position: absolute;\n        z-index: 999;\n        top: -9px;\n        left: 12px;\n        background: white;\n        font-weight: 400 !important;\n        font-size: 12px !important;\n        padding: 2px;\n    }\n\n    .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields {\n        position: relative;\n    }\n\n    .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields input, .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields select,\n    .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .phone_input {\n        width: 100%;\n    }\n\n    .area-executive-containers .area-executive-section .profile-info .profile-input .input-fields .multiselect_part {\n        max-width: none !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
